const mapping = {"O":"l","i":"v","e":"B","a":"n","k":"!","l":"e","v":"k","B":"O","n":"i"};
const reverse = Object.keys(mapping).reduce((result, letter) => Object.assign(result, { [mapping[letter]]: letter }), {});

export const encode = str => (""+str).replace(/./g, m => mapping[m] || m);
export const decode = str => (""+str).replace(/./g, m => reverse[m] || m);